import { render, staticRenderFns } from "./MtCursor.vue?vue&type=template&id=524a8daa&scoped=true&"
import script from "./MtCursor.vue?vue&type=script&lang=js&"
export * from "./MtCursor.vue?vue&type=script&lang=js&"
import style0 from "./MtCursor.vue?vue&type=style&index=0&id=524a8daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a8daa",
  null
  
)

export default component.exports